import { decrypt } from "../../common/client/encryption.js";
import { initAccounts, logIn } from "../../common/client/accounts.js";

// Pull in the styles which will be extractd into a file.
import "./style.scss";

// We pull in the dynamically generated security file which contains the
// seed for this build.
import security from "../../../build/dsadie/security.js";

initAccounts(security);

// Wait until the document loads to to do anything.
document.addEventListener("DOMContentLoaded", () => {
  wireSecurity();
  wireSidebar();
  wireLogin();
  wireDecryption();
});

function getSecurity() {
  if (isLoggedIn()) {
    return JSON.parse(localStorage.security);
  }

  return undefined;
}

function isLoggedIn() {
  return !!localStorage.security;
}

function wireDecryption() {
  // If we don't have a decryption block, then there is nothing to do.
  const block = document.getElementById("encrypted-content");
  const security = getSecurity();

  if (!block || !security) {
    return;
  }

  console.log("wireDecryption", "security", security);

  // Pull out the elements we care about.
  const iv = block.getAttribute("data-iv");
  const salt = block.getAttribute("data-salt");
  const access = block.getAttribute("data-access");
  const encrypted = block.getAttribute("data-encrypted");

  console.log("wireDecryption", { iv, access, salt });

  // We look up the AES key from the security object which may or may not be
  // correct... dun, dun, dun.
  const key = security.accessKeys[access];

  console.log("wireDecryption", "key", key);

  // Try to decrypt it. If we have good data, then we replace the block with
  // the content and hopefully the reader will never know our little swap out.
  const decrypted = decrypt(key, salt, iv, encrypted);

  if (decrypted) {
    console.log("replacing contents");
    block.innerHTML = decrypted;
  }
}

function wireSecurity() {
  console.log("wireSecurity", "isLoggedIn", isLoggedIn);
  document.body.classList.add(isLoggedIn() ? "logged-in" : "logged-out");

  const collection = document.getElementsByClassName("logout");

  for (let i = 0; i < collection.length; i++) {
    collection[i].addEventListener(
      "click",
      (event) => {
        localStorage.removeItem("security");
        window.location.reload();
        event.preventDefault();
      },
      false,
    );
  }
}

function wireLogin() {
  const form = document.getElementById("login");

  if (!form) {
    return;
  }

  const redirect = form.getAttribute("data-redirect");
  const userBox = document.getElementById("login-user");
  const passBox = document.getElementById("login-pass");
  const button = document.getElementById("login-submit");
  const message = document.getElementById("login-message");

  button.addEventListener(
    "click",
    (event) => {
      logIn(event);
    },
    false,
  );
}

function wireSidebar() {
  // Wire up the sidebar elements and controls.
  const sidebar = document.getElementById("sidebar");
  const sidebarScreen = document.getElementById("sidebar-screen");
  const sidebarClose = document.getElementById("sidebar-close");
  const sidebarOpen = document.getElementById("sidebar-open");

  function showSidebar() {
    sidebar.classList.add("sidebar-hidden");
    sidebar.classList.remove("sidebar-shown");
    sidebarScreen.classList.add("sidebar-hidden");
    sidebarScreen.classList.remove("sidebar-shown");
  }

  sidebarScreen.addEventListener(
    "click",
    () => {
      showSidebar();
    },
    false,
  );

  sidebarClose.addEventListener(
    "click",
    () => {
      showSidebar();
    },
    false,
  );

  sidebarOpen.addEventListener(
    "click",
    () => {
      sidebar.classList.remove("sidebar-hidden");
      sidebar.classList.add("sidebar-shown");
      sidebarScreen.classList.remove("sidebar-hidden");
      sidebarScreen.classList.add("sidebar-shown");
    },
    false,
  );
}
